import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import AnimatedBackground from "@/components/landing/AnimatedBackground";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Guarantees from "@/components/landing/Guarantees";
import Services from "@/components/landing/Services";
import WhackANail from "@/components/landing/games/WhackANail";
import Gallery from "@/components/landing/Gallery";
import Comparison from "@/components/landing/Comparison";
import TightenTheBolt from "@/components/landing/games/TightenTheBolt";
import Bonus from "@/components/landing/Bonus";
import Deposit from "@/components/landing/Deposit";
import Diagnostic from "@/components/landing/Diagnostic";
import BreakerMemory from "@/components/landing/games/BreakerMemory";
import About from "@/components/landing/About";
import ServiceArea from "@/components/landing/ServiceArea";
import Reviews from "@/components/landing/Reviews";
import Leaderboard from "@/components/landing/Leaderboard";
import ToolMatch from "@/components/landing/games/ToolMatch";
import StackTheBricks from "@/components/landing/games/StackTheBricks";
import Faq from "@/components/landing/Faq";
import ContactForm from "@/components/landing/ContactForm";
import Footer from "@/components/landing/Footer";

const GameShelf = ({ children, label }) => (
  <section className="py-10 max-w-4xl mx-auto px-4 sm:px-6">
    <div className="text-center mb-5">
      <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">{label}</span>
    </div>
    {children}
  </section>
);

function App() {
  return (
    <div className="App bg-[#232A31] text-[#1E252B] antialiased">
      <AnimatedBackground />
      <div className="relative z-10">
        <Nav />
        <main>
          <Hero />
          <Guarantees />
          <Services />
          <GameShelf label="Toolbox Game">
            <WhackANail />
          </GameShelf>
          <Gallery />
          <Comparison />
          <GameShelf label="Toolbox Game">
            <TightenTheBolt />
          </GameShelf>
          <Bonus />
          <Deposit />
          <Diagnostic />
          <GameShelf label="Toolbox Game">
            <BreakerMemory />
          </GameShelf>
          <About />
          <ServiceArea />
          <Reviews />
          <GameShelf label="Toolbox Game">
            <ToolMatch />
          </GameShelf>
          <GameShelf label="Lego Build-Off">
            <StackTheBricks />
          </GameShelf>
          <Leaderboard />
          <Faq />
          <ContactForm />
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
